import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { EmailTask } from './email-task'
import { emailTaskActions } from './email-task.actions'
import * as fromEmailTask from './email-task.reducer'
import { EmailTaskService } from './email-task.service'
import { concatMap, map, switchMap, take, tap } from 'rxjs/operators'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class EmailTaskEffects extends ResourceEffects<EmailTask> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public emailTaskService: EmailTaskService
  ) {
    super(
      fromEmailTask.FEATURE_NAME,
      emailTaskService,
      emailTaskActions,
      actions$
    )
  }

  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole: any
          this.store
            .select(persistentUserRoleSelectors.selectSelectedUserRole)
            .pipe(take(1))
            .subscribe((user) => {
              userRole = user
            })
          userRole && this.store.dispatch(emailTaskActions.resetState())
        })
      ),
    { dispatch: false }
  )
}
